// contexts/AccreditationContext.jsx
import { createContext, useContext, useState } from "react";

const AccreditationContext = createContext(null);

export const useAccreditation = () => useContext(AccreditationContext);

export const AccreditationProvider = ({ children }) => {
  const [accreditation, setAccreditation] = useState(null);

  return (
    <AccreditationContext.Provider value={{ accreditation, setAccreditation }}>
      {children}
    </AccreditationContext.Provider>
  );
};
